<template>
  <el-dialog
    :title="mode === 'view' ? '查看任务详情' : '任务执行'"
    :visible.sync="visible"
    width="1200px"
    custom-class="task-execution-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <div class="task-execution-container">
      <!-- 任务要求部分 -->
      <div class="task-requirements-section">
        <h3 class="section-title">任务要求</h3>
        <div class="requirements-details">
          <div class="detail-row detail-row1">
            <div class="detail-item">
              <span class="detail-label">大棚编号</span>
              <span class="detail-value">{{
                viewRow.greenhouseName || "-"
              }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">任务分类</span>
              <span class="detail-value">{{
                viewRow.categoryName || "-"
              }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">农事动作</span>
              <span class="detail-value">{{ viewRow.actions || "-" }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">重点防治病虫害</span>
              <span class="detail-value">{{ viewRow.pestControl || "-" }}</span>
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-item">
              <span class="detail-label">温湿度要求</span>
              <span class="detail-value">{{
                viewRow.stdHumidityTemp || "-"
              }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">执行时间</span>
              <span class="detail-value">{{
                formatDateRange(viewRow.execStartDate, viewRow.execEndDate) ||
                "执行时间"
              }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">注意事项</span>
              <span class="detail-value">{{ viewRow.precautions || "-" }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">指导文件</span>
              <span class="detail-value">
                <div
                  v-if="
                    viewRow.guidanceFiles && viewRow.guidanceFiles.length > 0
                  "
                  class="guidance-files-section"
                >
                  <div class="file-list">
                    <div
                      v-for="(file, index) in viewRow.guidanceFiles"
                      :key="index"
                      class="file-item"
                    >
                      <span class="file-name">{{ getFileName(file) }}</span>
                      <div class="file-actions">
                        <el-button
                          type="text"
                          size="mini"
                          @click="downloadFile(file)"
                          style="color: #409eff; margin-right: 5px"
                        >
                          下载
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
                <span v-else>-</span>
              </span>
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-item required">
              <span class="detail-label">执行人</span>
              <span class="detail-value">{{
                viewRow.executorNickName || viewRow.executorUsername || ""
              }}</span>
            </div>
            <div class="detail-item"></div>
          </div>
        </div>
      </div>

      <!-- 任务执行部分 -->
      <div
        class="task-execution-section"
        v-if="viewRow.execStatus !== 'COMPLETED' && mode === 'execute'"
      >
        <h3 class="section-title">任务执行</h3>

        <!-- 其他情况反馈 -->
        <div class="other-feedback-section">
          <div class="form-item">
            <label class="required-label">现场照片</label>
            <ImageUpload v-model="executionForm.otherImages" :maxCount="20" />
          </div>
          <div class="section-header">
            <h4 class="section-subtitle">备注</h4>
          </div>
          <div class="form-item">
            <el-input
              v-model="executionForm.otherFeedback"
              type="textarea"
              :rows="3"
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
      </div>

      <!-- 已完成任务的查看模式 -->
      <div
        class="task-view-section"
        v-if="viewRow.execStatus === 'COMPLETED' && mode === 'view'"
      >
        <h3 class="section-title">执行结果</h3>

        <!-- 农事动作完成情况 -->
        <!-- <div class="action-completion-header">
                    <h4 class="action-completion-title">农事动作完成情况</h4>
                    <div class="action-completion-result">
                        <span class="result-status">{{ viewRow.completed === 1 ? '完成' : '未完成' }}</span>
                    </div>
                </div> -->

        <!-- 重点防治病虫害情况 -->
        <!-- <div class="pest-control-header">
                    <h4 class="pest-control-title">重点防治病虫害情况</h4>
                    <div class="pest-control-result">
                        <span class="result-status">{{ viewRow.pestsDiseasesResult === 1 ? '有病虫害' : '无病虫害' }}</span>
                    </div>
                </div> -->

        <!-- 病虫害描述区域 -->
        <!-- <div v-if="viewRow.pestsDiseasesResult === 1" class="pest-description-area">
                    <div class="pest-description-section" v-if="viewRow.pestsDiseasesDesc">
                        <label class="result-label">病虫害描述</label>
                        <div class="result-content">{{ viewRow.pestsDiseasesDesc }}</div>
                    </div>
                    <div class="pest-photos-section" v-if="viewRow.pestsDiseasesImgs && viewRow.pestsDiseasesImgs.length > 0">
                        <label class="result-label">病虫害照片</label>
                        <div class="image-gallery">
                            <div v-for="(image, index) in viewRow.pestsDiseasesImgs" :key="index" class="image-item">
                                <img :src="getFullImageUrl(image)" alt="病虫害照片" @click="previewImage(image)" />
                            </div>
                        </div>
                    </div>
                </div> -->

        <!-- 温湿度控制情况 -->
        <!-- <div class="temp-humidity-header">
                    <h4 class="temp-humidity-title">温湿度控制情况</h4>
                    <div class="temp-humidity-result">
                        <span class="result-status">{{ viewRow.tempHumidityResult === 1 ? '合格' : '不合格' }}</span>
                    </div>
                </div> -->

        <!-- 温湿度数据表格 -->
        <!-- <div v-if="viewRow.tempHumidityData && viewRow.tempHumidityData.length > 0" class="device-status-section">
                    <el-table :data="viewRow.tempHumidityData" border style="width: 100%">
                        <el-table-column prop="deviceName" label="设备名称"></el-table-column>
                        <el-table-column prop="temperature" label="温度(°C)"></el-table-column>
                        <el-table-column prop="humidity" label="湿度(%)"></el-table-column>
                        <el-table-column prop="dataTime" label="最新更新时间">
                            <template slot-scope="scope">
                                {{ formatTime(scope.row.dataTime) }}
                            </template>
</el-table-column>
</el-table>
</div> -->

        <!-- 温湿度异常详情 -->
        <!-- <div v-if="viewRow.tempHumidityResult === 0" class="temp-humidity-details">
                    <div class="form-item" v-if="viewRow.tempHumidityDesc">
                        <label class="result-label">温湿度控制异常情况描述</label>
                        <div class="result-content">{{ viewRow.tempHumidityDesc }}</div>
                    </div>
                    <div class="form-item" v-if="viewRow.tempHumidityImgs && viewRow.tempHumidityImgs.length > 0">
                        <label class="result-label">不合格数据设备及照片</label>
                        <div class="image-gallery">
                            <div v-for="(image, index) in viewRow.tempHumidityImgs" :key="index" class="image-item">
                                <img :src="getFullImageUrl(image)" alt="温湿度异常照片" @click="previewImage(image)" />
                            </div>
                        </div>
                    </div>
                </div> -->

        <!-- 其他情况反馈 -->
        <div class="other-feedback-section">
          <div
            class="form-item"
            v-if="viewRow.otherImgs && viewRow.otherImgs.length > 0"
          >
            <label class="result-label">现场照片</label>
            <div class="image-gallery">
              <div
                v-for="(image, index) in viewRow.otherImgs"
                :key="index"
                class="image-item"
              >
                <img
                  :src="getFullImageUrl(image)"
                  alt="其他照片"
                  @click="previewImage(image)"
                />
              </div>
            </div>
          </div>
          <div class="section-header">
            <h4 class="section-subtitle">备注</h4>
          </div>
          <div class="form-item" v-if="viewRow.otherSituations">
            <div class="result-content">{{ viewRow.otherSituations }}</div>
          </div>
        </div>

        <!-- 执行时间 -->
        <div class="execution-time-section">
          <div class="form-item">
            <label class="result-label">实际执行时间</label>
            <div class="result-content">
              {{ formatTime(viewRow.realExecTime) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button
        v-if="viewRow.execStatus !== 'COMPLETED' && mode === 'execute'"
        type="primary"
        @click="handleSubmit"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";
import ImageUpload from "@/components/ImageUpload.vue";
import dayjs from "dayjs";

export default {
  name: "TaskExecutionDialog",
  components: {
    ImageUpload,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    taskData: {
      type: Object,
      default: () => ({}),
    },
    mode: {
      type: String,
      default: "view",
      validator: function (value) {
        return ["view", "execute"].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      viewRow: {},
      showDeviceStatus: false,
      executionForm: {
        otherFeedback: "",
        otherImages: [],
      },
      deviceStatusData: [],
    };
  },
  watch: {
    visible(val) {
      console.log("TaskExecutionDialog visible changed:", val);
      console.log("TaskExecutionDialog taskData:", this.taskData);
      if (val && this.taskData && this.taskData.id) {
        console.log("Fetching task detail for ID:", this.taskData.id);
        this.fetchTaskDetail(this.taskData.id);
      }
    },
    taskData: {
      handler(newVal) {
        console.log("TaskExecutionDialog taskData changed:", newVal);
        if (this.visible && newVal && newVal.id) {
          console.log("Fetching task detail for ID:", newVal.id);
          this.fetchTaskDetail(newVal.id);
        }
      },
      deep: true,
    },
  },
  methods: {
    async fetchTaskDetail(taskId) {
      try {
        const res = await axios.post(
          baseUrl +
            `/api/digital-farming/task/allot-record/detail-by-id/${taskId}`
        );
        if (res.code === 200) {
          this.viewRow = res.data;
          this.resetExecutionForm();

          if (this.viewRow.execStatus === "COMPLETED") {
            this.setCompletedFormData();
          }
        } else {
          this.$message.error("获取任务详情失败");
        }
      } catch (error) {
        console.error("获取任务详情失败:", error);
        this.$message.error("获取任务详情失败");
      }
    },
    setCompletedFormData() {
      this.executionForm.otherFeedback = this.viewRow.otherSituations || "";
      this.executionForm.otherImages = this.viewRow.otherImgs || [];

      // 温湿度数据不在这里设置，因为不再收集
    },
    resetExecutionForm() {
      this.showDeviceStatus = false;
      this.executionForm = {
        otherFeedback: "",
        otherImages: [],
      };
    },
    async getCurrentTempHumidity() {
      try {
        const res = await axios.post(
          baseUrl + "/api/digital-farming/task-record/getTempHumidityData"
        );
        if (res.code === 200 && res.data) {
          // 将API返回的数据转换为表格显示格式
          this.deviceStatusData = res.data.map((item) => ({
            deviceId: item.sensorId,
            deviceName: item.deviceName,
            temperature:
              typeof item.temperature === "number"
                ? item.temperature + "°C"
                : "-",
            humidity:
              typeof item.humidity === "number" ? item.humidity + "%" : "-",
            updateTime: item.dataTime ? this.formatTime(item.dataTime) : "-",
          }));
          this.showDeviceStatus = true;
        }
      } catch (error) {
        console.error("获取温湿度数据失败:", error);
        this.$message.error("获取温湿度数据失败");
      }
    },
    closeDeviceStatus() {
      this.showDeviceStatus = false;
      this.deviceStatusData = [];
    },
    async handleSubmit() {
      try {
        // 验证其他图片是否上传
        if (
          !this.executionForm.otherImages ||
          this.executionForm.otherImages.length === 0
        ) {
          this.$message.error("请上传现场照片");
          return;
        }

        // 构建提交数据 - 只包含其他情况反馈和其他图片
        const submitData = {
          id: this.viewRow.id,
          otherSituations: this.executionForm.otherFeedback,
          otherImgs: this.executionForm.otherImages || [],
        };
        console.log("执行数据", submitData);

        const res = await axios.post(
          baseUrl + `/api/digital-farming/task/allot-record/exec`,
          submitData
        );
        if (res.code === 200) {
          this.$message.success("任务执行成功");
          this.$emit("success");
          this.handleClose();
        } else {
        }
      } catch (error) {
        console.error("执行失败:", error);
      }
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
    viewGuidanceFiles() {
      if (this.viewRow.guidanceFiles && this.viewRow.guidanceFiles.length > 0) {
        console.log("指导文件:", this.viewRow.guidanceFiles);
        this.$message.info("指导文件功能开发中");
      }
    },
    formatTime(time) {
      if (!time) return "";
      const date = new Date(time);
      return date
        .toLocaleString("zh-CN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
        .replace(/\//g, "/");
    },
    formatDateRange(startDate, endDate) {
      if (!startDate || !endDate) return "";
      const start = new Date(startDate);
      const end = new Date(endDate);
      const formatDate = (date) => {
        return date.toLocaleDateString("zh-CN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      };
      return `${formatDate(start)} - ${formatDate(end)}`;
    },
    previewImage(imageUrl) {
      // 使用浏览器默认的图片预览功能
      const fullUrl = this.getFullImageUrl(imageUrl);
      window.open(fullUrl, "_blank");
    },
    getFullImageUrl(url) {
      if (!url) return "";
      // 如果已经是完整URL，直接返回
      if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
      }
      // 如果是相对路径，添加baseUrl
      return baseUrl + url;
    },
    getFileName(file) {
      if (typeof file === "string") {
        const list = file.split("/");
        return list[list.length - 1];
      }
      if (file && file.name) {
        return file.name;
      }
      if (file && file.url) {
        const list = file.url.split("/");
        return list[list.length - 1];
      }
      return "未知文件";
    },
    downloadFile(file) {
      try {
        let fileUrl = file;
        let fileName = this.getFileName(file);

        if (typeof file === "object" && file.url) {
          fileUrl = file.url;
          fileName = file.name || fileName;
        }

        const fullUrl = this.getFullImageUrl(fileUrl);

        // 使用简单的 a 标签下载
        const link = document.createElement("a");
        link.href = fullUrl;
        link.download = fileName;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$message.success("文件下载成功");
      } catch (error) {
        console.error("文件下载失败:", error);
        this.$message.error("文件下载失败");
      }
    },
  },
};
</script>

<style scoped lang="less">
/* 任务执行弹窗样式 */
.task-execution-dialog {
  .el-dialog__header {
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    color: #fff;
    border-bottom: 1px solid #2c3e50;
  }

  .el-dialog__body {
    background: #0f1419;
    color: #fff;
    padding: 20px;
  }

  .el-dialog__footer {
    background: #0f1419;
    border-top: 1px solid #2c3e50;
  }
}

.task-execution-container {
  .section-title {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #2680dd;
  }

  .task-requirements-section {
    margin-bottom: 30px;

    .requirements-details {
      .detail-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;

        .detail-item {
          display: flex;
          align-items: center;
          flex: 1;
          margin-right: 20px;

          &:last-child {
            margin-right: 0;
          }

          &.required {
            .detail-label::before {
              content: "*";
              color: #f56c6c;
              margin-right: 4px;
            }
          }

          .detail-label {
            color: #b6bcc7;
            font-size: 14px;
            font-weight: 500;
            margin-right: 10px;
            white-space: nowrap;
          }

          .detail-value {
            color: #fff;
            font-size: 14px;

            .guidance-files-section {
              .file-list {
                .file-item {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 8px 12px;
                  margin-bottom: 8px;
                  background: rgba(26, 26, 46, 0.3);
                  border-radius: 6px;
                  border: 1px solid #2c3e50;
                  transition: all 0.3s ease;

                  &:hover {
                    background: rgba(26, 26, 46, 0.5);
                    border-color: #2680dd;
                  }

                  &:last-child {
                    margin-bottom: 0;
                  }

                  .file-name {
                    color: #2680dd;
                    font-size: 13px;
                    font-weight: 500;
                    max-width: 200px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }

                  .file-actions {
                    display: flex;
                    align-items: center;
                    gap: 5px;

                    .el-button {
                      padding: 2px 6px;
                      font-size: 12px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .task-execution-section {
    .action-completion-header,
    .pest-control-header,
    .temp-humidity-header {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid rgba(44, 62, 80, 0.3);

      .action-completion-title,
      .pest-control-title,
      .temp-humidity-title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        margin: 0;
      }

      .action-completion-options,
      .pest-control-options,
      .temp-humidity-options {
        display: flex;
        margin-left: 15px;
        align-items: center;
        gap: 30px;

        .el-radio {
          color: #fff;

          .el-radio__label {
            color: #fff;
            font-size: 14px;
            font-weight: 500;
          }

          .el-radio__input.is-checked + .el-radio__label {
            color: #2680dd;
          }
        }

        .completion-tip {
          display: flex;
          align-items: center;
          margin-left: 20px;
        }
      }
    }

    .pest-description-area {
      margin-top: 20px;
      padding: 20px;
      background: rgba(26, 26, 46, 0.3);
      border-radius: 8px;
      border: 1px solid #2c3e50;

      .pest-description-section,
      .pest-photos-section {
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }

        .required-label {
          color: #fff;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 10px;
          display: block;

          &::before {
            content: "*";
            color: #f56c6c;
            margin-right: 4px;
          }
        }

        .pest-description-input {
          .el-textarea__inner {
            background: #1a1a2e;
            border-color: #2680dd;
            color: #fff;
            border-radius: 4px;

            &::placeholder {
              color: #8a8a8a;
            }
          }
        }

        .upload-section {
          display: flex;
          align-items: flex-start;
          gap: 15px;

          .image-previews {
            display: flex;
            gap: 10px;

            .image-preview {
              width: 80px;
              height: 60px;
              border: 1px solid #2c3e50;
              border-radius: 4px;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }
        }
      }
    }

    .pest-details-area {
      margin-top: 20px;
      padding: 20px;
      background: rgba(26, 26, 46, 0.3);
      border-radius: 8px;
      border: 1px solid #2c3e50;

      .pest-description-section,
      .pest-photos-section {
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }

        .required-label {
          color: #fff;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 10px;
          display: block;

          &::before {
            content: "*";
            color: #f56c6c;
            margin-right: 4px;
          }
        }

        .el-textarea {
          .el-textarea__inner {
            background: #1a1a2e;
            border-color: #2c3e50;
            color: #fff;
            border-radius: 4px;

            &::placeholder {
              color: #8a8a8a;
            }
          }
        }

        .upload-section {
          display: flex;
          align-items: flex-start;
          gap: 15px;

          .image-previews {
            display: flex;
            gap: 10px;

            .image-preview {
              width: 80px;
              height: 60px;
              border: 1px solid #2c3e50;
              border-radius: 4px;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }
        }
      }
    }

    .pest-details-section,
    .temp-humidity-details {
      margin-top: 20px;
      padding: 25px;
      background: rgba(26, 26, 46, 0.4);
      border-radius: 8px;
      border: 1px solid #2c3e50;

      .form-item {
        margin-bottom: 25px;

        &:last-child {
          margin-bottom: 0;
        }

        .required-label {
          color: #fff;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 10px;
          display: block;

          &::before {
            content: "*";
            color: #f56c6c;
            margin-right: 4px;
          }
        }

        .el-textarea {
          .el-textarea__inner {
            background: #1a1a2e;
            border-color: #2c3e50;
            color: #fff;
            border-radius: 4px;

            &::placeholder {
              color: #8a8a8a;
            }
          }
        }

        .upload-section {
          display: flex;
          align-items: flex-start;
          gap: 15px;

          .image-previews {
            display: flex;
            gap: 10px;

            .image-preview {
              width: 80px;
              height: 60px;
              border: 1px solid #2c3e50;
              border-radius: 4px;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }
        }
      }
    }

    .device-status-section {
      margin-top: 30px;
      padding: 25px;
      background: rgba(26, 26, 46, 0.3);
      border-radius: 8px;
      border: 1px solid #2c3e50;

      .device-status-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid rgba(44, 62, 80, 0.3);

        .device-status-title {
          color: #fff;
          font-size: 16px;
          font-weight: 600;
        }

        .close-button {
          color: #b6bcc7;
          font-size: 18px;
          padding: 0;
          transition: color 0.3s ease;

          &:hover {
            color: #f56c6c;
          }
        }
      }

      .subsection-title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 20px;
      }

      .el-table {
        background: transparent;

        .el-table__header-wrapper {
          background: #1a1a2e;
        }

        .el-table__body-wrapper {
          background: transparent;
        }

        th {
          background: #1a1a2e !important;
          color: #fff !important;
          border-color: #2c3e50 !important;
          font-weight: 500;
        }

        td {
          background: transparent !important;
          color: #fff !important;
          border-color: #2c3e50 !important;
        }
      }
    }
  }

  .task-view-section {
    .action-completion-header,
    .pest-control-header,
    .temp-humidity-header {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid rgba(44, 62, 80, 0.3);

      .action-completion-title,
      .pest-control-title,
      .temp-humidity-title {
        color: #fff;
        font-size: 16px;

        font-weight: 600;
        margin: 0;
      }

      .action-completion-result,
      .pest-control-result,
      .temp-humidity-result {
        .result-status {
          color: #2680dd;
          font-size: 14px;
          margin-left: 18px;
          font-weight: 500;
          padding: 4px 12px;
          background: rgba(38, 128, 221, 0.1);
          border-radius: 4px;
          border: 1px solid #2680dd;
        }
      }
    }

    .pest-description-area,
    .temp-humidity-details {
      margin-top: 20px;
      padding: 20px;
      background: rgba(26, 26, 46, 0.3);
      border-radius: 8px;
      border: 1px solid #2c3e50;

      .pest-description-section,
      .pest-photos-section,
      .form-item {
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }

        .result-label {
          color: #b6bcc7;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 10px;
          display: block;
        }

        .result-content {
          color: #fff;
          font-size: 14px;
          line-height: 1.6;
          padding: 10px;
          background: rgba(26, 26, 46, 0.5);
          border-radius: 4px;
          border: 1px solid #2c3e50;
        }

        .image-gallery {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;

          .image-item {
            width: 80px;
            height: 60px;
            border: 1px solid #2c3e50;
            border-radius: 4px;
            overflow: hidden;
            cursor: pointer;
            transition: transform 0.2s;

            &:hover {
              transform: scale(1.05);
            }

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }

    .other-feedback-section {
      margin-top: 20px;

      .section-header {
        margin-bottom: 15px;

        .section-subtitle {
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          margin: 0;
        }
      }

      .form-item {
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }

        .result-content {
          color: #fff;
          font-size: 14px;
          line-height: 1.6;
          padding: 10px;
          background: rgba(26, 26, 46, 0.5);
          border-radius: 4px;
          border: 1px solid #2c3e50;
        }

        .result-label {
          color: #b6bcc7;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 10px;
          display: block;
        }

        .image-gallery {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;

          .image-item {
            width: 80px;
            height: 60px;
            border: 1px solid #2c3e50;
            border-radius: 4px;
            overflow: hidden;
            cursor: pointer;
            transition: transform 0.2s;

            &:hover {
              transform: scale(1.05);
            }

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }

    .execution-time-section {
      margin-top: 20px;
      padding: 15px;
      background: rgba(26, 26, 46, 0.3);
      border-radius: 8px;
      border: 1px solid #2c3e50;

      .form-item {
        .result-label {
          color: #b6bcc7;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 10px;
          display: block;
        }

        .result-content {
          color: #fff;
          font-size: 14px;
          padding: 8px 12px;
          background: rgba(26, 26, 46, 0.5);
          border-radius: 4px;
          border: 1px solid #2c3e50;
        }
      }
    }
  }
}
</style>
